export default "__VITE_ASSET__CHJe4K1H__"